import { createAction, createAsyncActionTypes } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { createBackgroundAction, createPollerActions } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { getServiceReportArchiveUrl, getServiceReportOrdersToProcessUrl } from '../../../router/selectors';
import { prefix } from '../module';
import { navigateInBaseModal } from '../../app/actions/common';
import { isLoaded, getLastModified, hasOrders } from '../selectors/orderStatistics';
import { shouldFetch } from './util';

export const ORDER_STATISTICS_FETCH = prefix('ORDER_STATISTICS_FETCH');
export const ORDER_STATISTICS_RESET = prefix('ORDER_STATISTICS_RESET');
export const [ORDER_STATISTICS_FETCH_STARTED, ORDER_STATISTICS_FETCH_SUCCEEDED, ORDER_STATISTICS_FETCH_FAILED] =
    createAsyncActionTypes(ORDER_STATISTICS_FETCH);

const ORDER_STATISTICS_INTERVAL = 15 * 60 * 1000;

export const resetOrderStatistics = (): CommanderThunkAction => (dispatch) => {
    dispatch(createAction(ORDER_STATISTICS_RESET));
    dispatch(destroyOrderStatisticsPoller());
};

const shouldFetchOrderStatistics = shouldFetch(isLoaded, getLastModified, ORDER_STATISTICS_INTERVAL);
const fetchOrderStatistics =
    (serviceId: string): CommanderThunkAction =>
    async (dispatch, getState, { container, appClockService }) => {
        const { serviceComponent } = container();
        const state = getState();
        if (shouldFetchOrderStatistics(state, appClockService.getValue())) {
            const enterpriseId = getCurrentEnterpriseId();
            const promise = serviceComponent.getOrderStatistics(enterpriseId, serviceId).then((stats: $TSFixMe) => ({
                ...stats,
                lastModified: appClockService.getValue(),
            }));
            return dispatch(createBackgroundAction(ORDER_STATISTICS_FETCH, promise));
        }
    };

export const [startOrderStatisticsPoller, stopOrderStatisticsPoller, destroyOrderStatisticsPoller] =
    createPollerActions(fetchOrderStatistics, ORDER_STATISTICS_INTERVAL);

export const navigateToServiceReport =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();

        const enterpriseId = getCurrentEnterpriseId();
        const serviceId = getSelectedServiceId(state);

        let url = getServiceReportArchiveUrl(state, { enterpriseId, serviceId, resolveRoute });

        if (hasOrders(state)) {
            url = getServiceReportOrdersToProcessUrl(state, { enterpriseId, serviceId, resolveRoute });
        }

        dispatch(navigateInBaseModal(url));
    };
